export default "__VITE_ASSET__e48bca69__"